import { render, staticRenderFns } from "./AddToMobileWalletInstructions.vue?vue&type=template&id=a526b4ac&scoped=true"
import script from "./AddToMobileWalletInstructions.vue?vue&type=script&lang=js"
export * from "./AddToMobileWalletInstructions.vue?vue&type=script&lang=js"
import style0 from "./AddToMobileWalletInstructions.vue?vue&type=style&index=0&id=a526b4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a526b4ac",
  null
  
)

export default component.exports